<template>
<div class="content">
  <van-nav-bar @click-left="onClickLeft">
    <template #left>
      <img style="width: 2.66667vw;height: 5.33333vw;display: inline-block;" :src="require('../../assets/'+appTheme+'/navBack.png')" alt="" />
    </template>
  </van-nav-bar>
  <van-address-list
    v-model="chosenAddressId"
    :list="list"
    :switchable="switchableClick"
    @select="goOrderPay"
    add-button-text="+新增地址"
    default-tag-text="默认"
    @add="onAdd"
    @edit="onEdit"
  />
</div>
</template>

<script>
import { addressList } from '@/api/goods'
export default {
  name: "addressList",
  data() {
    return {
      appTheme:this.$store.state.appTheme,
      chosenAddressId: '',
      list: [],
      listArr: [],
      switchableClick: false,
      comType:0 // 1 商品下单进来  0 我的界面进来 2购物车下单界面进来
    }
  },
  created() {
    var type = this.$route.query.type
    if (type != undefined){
      this.comType = type
      this.switchableClick = true
    }
    this.getList()
  },
  methods: {
    getList(){
      var that = this
      addressList().then(res => {
        if(res.code == 200)
        {
          console.log('res',res.data.data)
          var arr = res.data.data
          var arrSec = JSON.parse(JSON.stringify(arr).replace(/phone/g,'tel').replace(/is_default/g,'isDefault'))
          var arrEdit = JSON.parse(JSON.stringify(arr).replace(/phone/g,'tel').replace(/is_default/g,'isDefault'))
          this.listArr = arrEdit
          console.log('listarr',this.listArr)
         for (var i=0;i<arrSec.length;i++){
            arrSec[i].address = arrSec[i].area+ arrSec[i].address
         }
          this.list = arrSec
        }
        else
        {
          this.$toast(res.message)
          this.$router.push('/');
        }
      })
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    onAdd() {
      // this.Toast('新增地址');
      this.$router.push({path:'/addressEdit'})
    },
    onEdit(index) {
      console.log('编辑地址:', index);
      console.log(this.listArr)
      for (var i=0;i<this.listArr.length;i++){
        if (this.listArr[i].id == index.id){
          console.log(this.listArr[i])
          this.$router.push({path:'/addressEdit',query: {item: this.listArr[i]}})
        }
      }

    },
    goOrderPay(item){
      console.log(item)
      if (this.comType==1){ // 下单商品进来
        // this.$router.push({path:'/orderPay',query: {item:item}})
        const addDate = JSON.stringify(item)
        this.$store.commit("setAddressInfo",item);
        // localStorage.setItem('addressCurrent', addDate)
        this.$router.go(-1)
        // this.$router.back()
      } else if (this.comType==2){ // 购物车下单界面进来
        const addDate = JSON.stringify(item)
        this.$store.commit("setAddressInfo",item);
        this.$router.go(-1)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.van-nav-bar {
  background: #FDD80D;color: #333333;font-weight: bold;font-size: 30px;
}
.van-nav-bar .van-icon {
  color: #333333;
}
.van-address-item .van-radio__icon--checked .van-icon {
  background-color: #FDD80D;
  border-color: #FDD80D;
}
.van-button--danger {
  color: #282828;
  background-color: #FDD80D;
  border: 0.02667rem solid #FDD80D;
}
.van-tag--round {
  border-radius: 2px;padding:2px 8px; line-height: auto;
}
</style>
